import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import CutileiScheduleList from 'components/Lists/CutileiScheduleList'
import Select from 'components/Inputs/Select'
import DateInput from 'components/Inputs/DateInput'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { Container, FilterContainer } from './styles'
import { DateTime } from 'luxon'

const STATUS_LIST = [
  {label: 'Todos', value: 'all'},
  {label: 'Não cancelados', value: 'not_canceled'},
  {label: 'Cancelados', value: 'canceled'}
]

export default function Schedules ({ member }) {
  const now = DateTime.now ().setLocale ('pt-BR')
  const [loading, setLoading] = useState (true)
  const [page, setPage] = useState (1)
  const [lastPage, setLastPage] = useState (0)
  const [total, setTotal] = useState (0)
  const [schedules, setSchedules] = useState ([])
  const [scheduleStatuses, setScheduleStatuses] = useState ([])
  const [scheduleData, setScheduleData] = useState (null)
  const [businesses, setBusinesses] = useState ([])
  const [status, setStatus] = useState (STATUS_LIST[0])
  const [business, setBusiness] = useState (null)
  const [dateRange, setDateRange] = useState ([
    now.startOf ('month').toISODate (),
    now.toISODate ()
  ])
  // const [showScheduleDetailsModal, setShowScheduleDetailsModal] = useState (false)
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getData ()
  }, [])

  useEffect (() => {
    setLoading (true)
    getSchedules (1)
  }, [status, dateRange, business])

  const getData = async () => {
    try {
      const { data: businesses } = await cutileiApi.get (
        `/businesses?member_id=${member.id}&page=1&per_page=9999`,
        requestConfig
      )

      const { data: scheduleStatuses } = await cutileiApi.get (
        '/schedule_statuses', requestConfig
      )

      setScheduleStatuses (scheduleStatuses)
      setBusinesses (businesses.data.map (business => ({
        label: business.name,
        value: business.id
      })))
    } catch (error) {
      logApiError (error)
    }
  }

  const getSchedules = async (pageNumber = page)  => {
    if (lastPage && pageNumber > lastPage) return

    const startDate = dateRange ? dateRange[0] : null
    const endDate = dateRange ? dateRange[1] : null
    let statusFilters = '&canceled=false'

    if (status.value === 'canceled') statusFilters = '&canceled=true'
    else if (status.value === 'all') statusFilters = '&canceled=all'

    const filters = `&start_date=${startDate}&end_date=${endDate}`
                  + `&business_id=${business?.value || ''}&order=desc${statusFilters}`

    try {
      const { data: schedulesResponse } = await cutileiApi.get (
        `/schedules?member_id=${member.id}&page=${pageNumber}&per_page=25${filters}`,
        requestConfig
      )
      const { data, meta } = schedulesResponse

      pageNumber > 1 ? setSchedules ([...schedules, ...data]) : setSchedules (data)
      setPage (pageNumber + 1)
      setLastPage (meta.last_page)
      setTotal (meta.total)
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  // const compareSchedules = (a, b) => {
  //   const AstartTime = a.start_time || a.time
  //   const BstartTime = b.start_time || b.time

  //   return DateTime.fromISO (AstartTime).toMillis () - DateTime.fromISO (BstartTime).toMillis ()
  // }

  // const handleEditSchedule = schedule => {
  //   setSchedules ([schedule, schedules.filter (s => s.id !== schedule.id)].sort (compareSchedules))
  // }

  // const handleDeleteSchedule = schedule => setSchedules (schedules.filter (s => s.id !== schedule.id))

  // const toggleScheduleDetailsModal = () => setShowScheduleDetailsModal (!showScheduleDetailsModal)

  return (
    <Container>
      <FilterContainer>
        <Select
          name='status'
          placeholder='Status...'
          value={status}
          options={STATUS_LIST}
          onChange={(_, option) => setStatus (option)}
        />
        <DateInput
          value={dateRange}
          selectRange={true}
          onChange={setDateRange}
        />
        <Select
          name='business'
          placeholder='Salão...'
          value={business}
          options={businesses}
          isClearable={true}
          onChange={(_, option) => setBusiness (option)}
        />
      </FilterContainer>
      {loading ? <Loading style={{marginTop: 10}}/> : (
        <CutileiScheduleList
          schedules={schedules}
          totalSchedules={total}
          scheduleStatuses={scheduleStatuses}
          hasMore={!(lastPage && page > lastPage)}
          onScroll={getSchedules}
          onScheduleSelected={setScheduleData}
          scrollableTarget='member-details-modal'
        />
      )}
    </Container>
  )
}
